module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/PaymentDaysCalculationType.ejs -->\n\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Basis for '+
((__t=( model.text ))==null?'':_.escape(__t))+
' Calculation\n        <i class="fa fa-question-circle" data-toggle="tooltip"\n        data-placement="top" data-container="body"\n        data-html="true"\n        title=\''+
((__t=( model.title ))==null?'':_.escape(__t))+
'\'>\n        </i>\n    </label>\n    <div id="'+
((__t=( model.name ))==null?'':_.escape(__t))+
'CalculationTypeContainer"\n        class="col-sm-'+
((__t=( model.calculationType === 1 ? 4 : 9 ))==null?'':_.escape(__t))+
'">\n        <select class="form-control"\n            name="'+
((__t=( model.name ))==null?'':_.escape(__t))+
'CalculationType"\n            data-value-type="integer"\n            '+
((__t=( model.isEnabled ? '' : 'disabled' ))==null?'':_.escape(__t))+
'>\n            <option value="1"\n                '+
((__t=( model.calculationType === 1 ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Fixed Number of Days\n            </option>\n            <option value="3"\n                '+
((__t=( model.calculationType === 3 ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Working Days in Current Calendar Month\n            </option>\n            <option value="2"\n                '+
((__t=( model.calculationType === 2 ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                All Days in Current Calendar Month\n            </option>\n        </select>\n        <span class="error error-'+
((__t=( model.name ))==null?'':_.escape(__t))+
'CalculationType"></span>\n    </div>\n\n    <div id="'+
((__t=( model.name ))==null?'':_.escape(__t))+
'FixedDaysContainer"\n        '+
((__t=( model.calculationType === 1 ? '' : 'style=display:none' ))==null?'':_.escape(__t))+
'>\n        <label class="col-sm-2 control-label">\n            Fixed Days\n        </label>\n        <div class="col-sm-3">\n            <input type="text" class="form-control"\n                data-value-type="integer"\n                name="'+
((__t=( model.name ))==null?'':_.escape(__t))+
'FixedDays"\n                value="'+
((__t=( model.fixedDays ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.isEnabled ? '' : 'disabled' ))==null?'':_.escape(__t))+
'>\n            <span class="error error-'+
((__t=( model.name ))==null?'':_.escape(__t))+
'FixedDays"></span>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/PaymentDaysCalculationType.ejs
// module id = 855
// module chunks = 1